export var ApiEntityType;
(function (ApiEntityType) {
    ApiEntityType["AlarmElectricalDamage"] = "AlarmElectricalDamage";
    ApiEntityType["Allowance"] = "Allowance";
    ApiEntityType["AntennaDamage"] = "AntennaDamage";
    ApiEntityType["ArtisanAppointment"] = "ArtisanAppointment";
    ApiEntityType["AwningDamage"] = "AwningDamage";
    ApiEntityType["AwningGlassDamage"] = "AwningGlassDamage";
    ApiEntityType["BreakInDamage"] = "BreakInDamage";
    ApiEntityType["Charge"] = "Charge";
    ApiEntityType["ChimneyDamage"] = "ChimneyDamage";
    ApiEntityType["Claim"] = "Claim";
    ApiEntityType["Contract"] = "Contract";
    ApiEntityType["Counting"] = "Counting";
    ApiEntityType["Cover"] = "Cover";
    ApiEntityType["CoveringCategory"] = "CoveringCategory";
    ApiEntityType["CustomDamage"] = "CustomDamage";
    ApiEntityType["DocumentAnalyse"] = "DocumentAnalyse";
    ApiEntityType["DocumentAnalyseGroup"] = "DocumentAnalyseGroup";
    ApiEntityType["DocumentAnalyseValue"] = "DocumentAnalyseValue";
    ApiEntityType["DocumentCheck"] = "DocumentCheck";
    ApiEntityType["DoorBreakInDamage"] = "DoorBreakInDamage";
    ApiEntityType["DoorDamage"] = "DoorDamage";
    ApiEntityType["DroughtDamageQualification"] = "DroughtDamageQualification";
    ApiEntityType["ElectricalDamage"] = "ElectricalDamage";
    ApiEntityType["ElectricalDamageQualification"] = "ElectricalDamageQualification";
    ApiEntityType["Equipment"] = "Equipment";
    ApiEntityType["ExpertAppointment"] = "ExpertAppointment";
    ApiEntityType["ExternalDamage"] = "ExternalDamage";
    ApiEntityType["ExternalPersonalPropertyDamage"] = "ExternalPersonalPropertyDamage";
    ApiEntityType["FenceBreakInDamage"] = "FenceBreakInDamage";
    ApiEntityType["FenceDamage"] = "FenceDamage";
    ApiEntityType["FireDamageQualification"] = "FireDamageQualification";
    ApiEntityType["FixedBayWindowGlassDamage"] = "FixedBayWindowGlassDamage";
    ApiEntityType["FrameworkDamage"] = "FrameworkDamage";
    ApiEntityType["FrenchWindowBreakInDamage"] = "FrenchWindowBreakInDamage";
    ApiEntityType["FrenchWindowGlassDamage"] = "FrenchWindowGlassDamage";
    ApiEntityType["GarageDoorBreakInDamage"] = "GarageDoorBreakInDamage";
    ApiEntityType["GarageDoorDamage"] = "GarageDoorDamage";
    ApiEntityType["GarageDoorMotorizationElectricalDamage"] = "GarageDoorMotorizationElectricalDamage";
    ApiEntityType["GardenShelterDamage"] = "GardenShelterDamage";
    ApiEntityType["GateBreakInDamage"] = "GateBreakInDamage";
    ApiEntityType["GateDamage"] = "GateDamage";
    ApiEntityType["GateMotorizationElectricalDamage"] = "GateMotorizationElectricalDamage";
    ApiEntityType["GlassBreakageDamageQualification"] = "GlassBreakageDamageQualification";
    ApiEntityType["GlassBreakageDamageInvoice"] = "GlassBreakageDamageInvoice";
    ApiEntityType["GlassDamage"] = "GlassDamage";
    ApiEntityType["GlassWallGlassDamage"] = "GlassWallGlassDamage";
    ApiEntityType["GoodDamage"] = "GoodDamage";
    ApiEntityType["GreenhouseGlassDamage"] = "GreenhouseGlassDamage";
    ApiEntityType["GutterDamage"] = "GutterDamage";
    ApiEntityType["HeatPumpElectricalDamage"] = "HeatPumpElectricalDamage";
    ApiEntityType["HeliosDeclaration"] = "HeliosDeclaration";
    ApiEntityType["InsuranceContract"] = "InsuranceContract";
    ApiEntityType["IntercomElectricalDamage"] = "IntercomElectricalDamage";
    ApiEntityType["LittleGateBreakInDamage"] = "LittleGateBreakInDamage";
    ApiEntityType["LittleGateDamage"] = "LittleGateDamage";
    ApiEntityType["MessageTemplate"] = "MessageTemplate";
    ApiEntityType["OptionalAllowance"] = "OptionalAllowance";
    ApiEntityType["OtherBreakInDamage"] = "OtherBreakInDamage";
    ApiEntityType["OtherDamage"] = "OtherDamage";
    ApiEntityType["OtherElectricalDamage"] = "OtherElectricalDamage";
    ApiEntityType["OtherGlassDamage"] = "OtherGlassDamage";
    ApiEntityType["PergolaDamage"] = "PergolaDamage";
    ApiEntityType["PergolaGlassDamage"] = "PergolaGlassDamage";
    ApiEntityType["PersonalProperty"] = "PersonalProperty";
    ApiEntityType["PersonalPropertyCategory"] = "PersonalPropertyCategory";
    ApiEntityType["PersonalPropertyCategoryConfigurationPerGuarantee"] = "PersonalPropertyCategoryConfigurationPerGuarantee";
    ApiEntityType["PersonalPropertyReceipt"] = "PersonalPropertyReceipt";
    ApiEntityType["PhotovoltaicPanelsElectricalDamage"] = "PhotovoltaicPanelsElectricalDamage";
    ApiEntityType["PlantsDamage"] = "PlantsDamage";
    ApiEntityType["Receipt"] = "Receipt";
    ApiEntityType["RobberyDamageQualification"] = "RobberyDamageQualification";
    ApiEntityType["RollingShuttersMotorizationElectricalDamage"] = "RollingShuttersMotorizationElectricalDamage";
    ApiEntityType["RoofDamage"] = "RoofDamage";
    ApiEntityType["RoofHoleDamage"] = "RoofHoleDamage";
    ApiEntityType["RoomDamage"] = "RoomDamage";
    ApiEntityType["ShowerWallGlassDamage"] = "ShowerWallGlassDamage";
    ApiEntityType["ShutterBreakInDamage"] = "ShutterBreakInDamage";
    ApiEntityType["ShuttersDamage"] = "ShuttersDamage";
    ApiEntityType["SlidingBayWindowBreakInDamage"] = "SlidingBayWindowBreakInDamage";
    ApiEntityType["SlidingBayWindowGlassDamage"] = "SlidingBayWindowGlassDamage";
    ApiEntityType["SpecificOptionCondition"] = "SpecificOptionCondition";
    ApiEntityType["StoneWorkDamage"] = "StoneWorkDamage";
    ApiEntityType["StormSnowHailDamageQualification"] = "StormSnowHailDamageQualification";
    ApiEntityType["SurfaceDamage"] = "SurfaceDamage";
    ApiEntityType["SwimpoolCoverDamage"] = "SwimpoolCoverDamage";
    ApiEntityType["SwimpoolCoverDamagePanel"] = "SwimpoolCoverDamagePanel";
    ApiEntityType["SwimpoolCoverGlassDamage"] = "SwimpoolCoverGlassDamage";
    ApiEntityType["SwimpoolElectricalDamage"] = "SwimpoolElectricalDamage";
    ApiEntityType["TerraceFloorDamage"] = "TerraceFloorDamage";
    ApiEntityType["ThirdParty"] = "ThirdParty";
    ApiEntityType["TileDisplacementDamage"] = "TileDisplacementDamage";
    ApiEntityType["TransomGlassDamage"] = "TransomGlassDamage";
    ApiEntityType["UploadedAppFile"] = "UploadedAppFile";
    ApiEntityType["UploadedAppFileCollection"] = "UploadedAppFileCollection";
    ApiEntityType["User"] = "User";
    ApiEntityType["VeluxGlassDamage"] = "VeluxGlassDamage";
    ApiEntityType["VerandaDamage"] = "VerandaDamage";
    ApiEntityType["VerandaDamagePanel"] = "VerandaDamagePanel";
    ApiEntityType["VerandaGlassDamage"] = "VerandaGlassDamage";
    ApiEntityType["Warning"] = "Warning";
    ApiEntityType["WaterDamageQualification"] = "WaterDamageQualification";
    ApiEntityType["WindowBreakInDamage"] = "WindowBreakInDamage";
    ApiEntityType["WindowDamage"] = "WindowDamage";
    ApiEntityType["WindowGlassDamage"] = "WindowGlassDamage";
})(ApiEntityType || (ApiEntityType = {}));
